import { type FC } from "react";
import { Controller, type Control } from "react-hook-form";

import { LabelWrapper } from "@ds/components/forms/labels";

import { DeviceTargets } from "./targets/device-targets";

export const DeploymentTargetsDevicesControl: FC<{ control: Control<Deployment> }> = ({ control }) => (
  <Controller
    name="targets"
    control={control}
    render={({ field: { ref, ...restFields }, fieldState }) => (
      <LabelWrapper label="Players" className="col-8" error={fieldState.error} isRequired>
        <DeviceTargets inputRef={ref} {...restFields} />
      </LabelWrapper>
    )}
  />
);
